import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { editInquiryInfo, getInquiryById } from "../../../../redux/features/inquiries/inquiriesService";
import styles from './index.module.css';
import BeatLoader from "react-spinners/BeatLoader";
import GridLoader from "react-spinners/GridLoader";
import { showToast } from "../../../../components/ToastMsg";
import { getWithdrawalById, updateWithdrawalStatus } from "../../../../redux/features/withdrawals/withdrawalsService";
import { faCircleCheck, faCircleXmark, faXmark } from "@fortawesome/free-solid-svg-icons";
import Modal from "../../../../components/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ViewRequest = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isWithdrawLoading, withdrawRequestDetails } = useSelector((state) => state.withdrawal.withdrawDetails);
    const { isInquiryUpdateing } = useSelector((state) => state.inquiry.updateInquiryDetails);

    const [isRejectLoading, setRejectLoading] = useState(false);
    const [isCompleteLoading, setCompleteLoading] = useState(false);
    const [isModalOpen, setModalOpen] = useState(false);
    const [isRejectModalOpen, setRejectModalOpen] = useState(false);
    const [remark, setRemark] = useState(null);
    const [errorMsg, setErrorMsg] = useState(null);

    const handleInputChange = (event) => {
        setRemark(event.target.value);
    };

    const handleAcceptInputChange = (event) => {
        setRemark(event.target.value);
    }

    useEffect(() => {
        dispatch(getWithdrawalById(id));
    }, [dispatch, id]);

    const closeModal = () => setModalOpen(false);

    const handleYes = async () => {
        if (!remark || !remark.trim()) {
            setErrorMsg('Please add a remark.');
        }
        else {
            closeRejectModal();
            dispatch(updateWithdrawalStatus({ id: id, withdrawal_request_status: 'Approved', remark: remark }))
                .unwrap()
                .then((response) => {
                    if (response.success === true) {
                        showToast("success", response.message);
                        navigate('/admin/withdrawals');
                    } else {
                        showToast("error", response.message);
                    }
                    setRemark(null);
                })
                .catch((error) => {
                    setRemark(null);
                    showToast("error", error.message);
                });
        }
    }

    const closeRejectModal = () => {
        setRejectModalOpen(false);
        setRemark('');
        setErrorMsg('')
    }

    const handleRejectYes = async () => {
        if (!remark || !remark.trim()) {
            setErrorMsg('Please add a remark.')
        } else {
            dispatch(updateWithdrawalStatus({ id: id, withdrawal_request_status: 'Rejected', remark: remark }))
                .unwrap()
                .then((response) => {
                    if (response.success === true) {
                        showToast("success", response.message);
                        navigate('/admin/withdrawals');
                    } else {
                        showToast("error", response.message);
                    }
                    closeRejectModal();
                    setRemark(null);
                })
                .catch((error) => {
                    closeRejectModal();
                    setRemark(null);
                    showToast("error", error.message);
                });
        }
    };

    return (
        <div className={`main-card`}>
            <div className={`main-card-body`}>
                <h1 className={`form-title ${styles.headDiv}`}>
                    Withdraw Request Details
                </h1>
            </div>
            {isWithdrawLoading ?
                <div className={`loader-style`}>
                    <GridLoader color="#1D0C50" />
                </div>
                :
                <>
                    <div className={styles.tableWrapper}>
                        <table className={styles.table}>
                            <tbody className={styles.tbody}>
                                <tr>
                                    <td className={styles.tdataColumnOne}>Name</td>
                                    <td className={styles.tdataColumnTwo}>{withdrawRequestDetails?.wallet?.user?.full_name}</td>
                                </tr>
                                <tr>
                                    <td className={styles.tdataColumnOne}>NIC</td>
                                    <td className={styles.tdataColumnTwo}>{withdrawRequestDetails?.wallet?.user?.nic}</td>
                                </tr>
                                <tr>
                                    <td className={styles.tdataColumnOne}>Phone Number</td>
                                    <td className={styles.tdataColumnTwo}>{withdrawRequestDetails?.wallet?.user?.phone_number}</td>
                                </tr>
                                <tr>
                                    <td className={styles.tdataColumnOne}>Account Holder Name</td>
                                    <td className={styles.tdataColumnTwo} style={{ fontWeight: 'bold' }}>{withdrawRequestDetails?.account_holder_name}</td>
                                </tr>
                                <tr className={styles.msgRow}>
                                    <td className={styles.tdataColumnOne}>Bank</td>
                                    <td className={styles.tdataColumnTwo}>{withdrawRequestDetails?.bank_name}</td>
                                </tr>
                                <tr className={styles.msgRow}>
                                    <td className={styles.tdataColumnOne}>Branch</td>
                                    <td className={styles.tdataColumnTwo}>{withdrawRequestDetails?.branch}</td>
                                </tr>
                                <tr className={styles.msgRow}>
                                    <td className={styles.tdataColumnOne}>Account Number</td>
                                    <td className={styles.tdataColumnTwo}>{withdrawRequestDetails?.account_number}</td>
                                </tr>
                                <tr className={styles.msgRow}>
                                    <td className={styles.tdataColumnOne}>Amount</td>
                                    <td className={styles.tdataColumnTwo}>{withdrawRequestDetails?.amount?.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td className={styles.tdataColumnOne}>Status</td>
                                    <td className={styles.tdataColumnTwo}> <span className={`status-text-label ${withdrawRequestDetails?.withdrawal_request_status?.toLowerCase()}`}>{withdrawRequestDetails?.withdrawal_request_status}</span></td>
                                </tr>
                                <tr className={styles.msgRow}>
                                    <td className={styles.tdataColumnOne}>Remark</td>
                                    <td className={styles.tdataColumnTwo}>{withdrawRequestDetails?.remark}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {withdrawRequestDetails?.withdrawal_request_status !== 'Approved' && withdrawRequestDetails?.withdrawal_request_status !== 'Rejected' &&
                        <div className={styles.btnRow}>
                            <button
                                className={`btn-primary`}
                                type='button'
                                disabled={isInquiryUpdateing}
                                onClick={() => setRejectModalOpen(true)}
                                style={{ backgroundColor: "var(--danger", borderColor: "var(--danger" }}
                            >
                                {isRejectLoading ? (
                                    <BeatLoader grade='#ffffff' />
                                ) : (
                                    `Reject`
                                )}
                            </button>
                            <button
                                className={`btn-primary`}
                                type='button'
                                disabled={isInquiryUpdateing}
                                onClick={() => setModalOpen(true)}
                                style={{ backgroundColor: "var(--green", borderColor: "var(--green" }}
                            >
                                {isCompleteLoading ? (
                                    <BeatLoader grade='#ffffff' />
                                ) : (
                                    `Approve`
                                )}
                            </button>
                        </div>
                    }
                </>
            }
            {isModalOpen && (
                <div className={`main-container`}>
                    <div className={styles.walletModal}>
                        <div className={styles.walletModalContainer}>
                            <div className={styles.closeRow}>
                                <p className={styles.walletTitle}>Approve withdrawal request</p>
                                <FontAwesomeIcon icon={faXmark} className={styles.xClass} size="2xl" onClick={() => {
                                    setModalOpen(false);
                                    document.body.style.overflow = 'unset';
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                    setErrorMsg(null);
                                    setRemark(null);
                                }} />
                            </div>
                            <div className={styles.walletModalBody}>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='amount' className={`form-label`}>
                                            Remark{" "}
                                            <span className={styles.note}>(Add a remark to identify payment done through the bank. Ex: Reference number in the pay slip)</span>
                                        </label>
                                        <input
                                            type='text'
                                            id='remark'
                                            name='remark'
                                            value={remark}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setRemark(value);
                                                setErrorMsg(null);
                                            }}
                                            placeholder='Enter the remark'
                                            className={`form-input-default`}
                                        />
                                        {errorMsg && (
                                            <p className={`text-danger`}>{errorMsg}</p>
                                        )}
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    onClick={handleYes}
                                    className={styles.submitBtn}>Approve</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {isRejectModalOpen && (
                <div className={`main-container`}>
                    <div className={styles.walletModal}>
                        <div className={styles.walletModalContainer}>
                            <div className={styles.closeRow}>
                                <p className={styles.walletTitle}>Reject withdrawal request</p>
                                <FontAwesomeIcon icon={faXmark} className={styles.xClass} size="2xl" onClick={() => {
                                    setRejectModalOpen(false);
                                    document.body.style.overflow = 'unset';
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                    setErrorMsg(null);
                                    setRemark(null);
                                }} />
                            </div>
                            <div className={styles.walletModalBody}>
                                <div className={`form-input-row`}>
                                    <div className={`form-input-group`}>
                                        <label htmlFor='amount' className={`form-label`}>
                                            Remark
                                        </label>
                                        <input
                                            type='text'
                                            id='remark'
                                            name='remark'
                                            value={remark}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                setRemark(value);
                                                setErrorMsg(null);
                                            }}
                                            placeholder='Enter the remark'
                                            className={`form-input-default`}
                                        />
                                        {errorMsg && (
                                            <p className={`text-danger`}>{errorMsg}</p>
                                        )}
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    onClick={handleRejectYes}
                                    className={styles.submitBtn}>Reject</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ViewRequest;